import React from "react";
import FindPharmacy from '../findPharmacy/findPharmacy';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";

export default class TransferPharmacy extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.completed = props.completed;
        this.destinationPharmacy = props.destinationPharmacy;
        this.state = { selectedPharmacy: this.destinationPharmacy };
    }

    onPharmacySelected(pharmacy) {
        const { goNext, onPharmacySelected } = this.props;
        this.destinationPharmacy = pharmacy;
        this.setState({ selectedPharmacy: pharmacy });
        logUI("MBHWeb.Rx.Transfer.External.SelectPharmacy", new Date(), Tools.getURLPath());
        goNext();
        onPharmacySelected(pharmacy);
    }

    findAnotherPharmacy = () => {
        this.setState({ selectedPharmacy: null });
        this.destinationPharmacy = null;        
    }

    isValid() {
        return this.destinationPharmacy !== null;
    }

    render() {
        const { selectedPharmacy } = this.state;
        const { sourceStoreNumber } = this.props;

        return (
            <div style={this.props.style}>
                <div className="select-pharmacy-container">
                    <div className="row">
                        <div className="col-12 maxWidth-content">
                            <div className="row">
                                <div className="col-12">
                                    <h2 className="step-heading desktop-element">
                                        Where are you transferring these prescriptions?
                                    </h2>
                                </div>
                                <div className="col-12">
                                    <FindPharmacy action="transfer" onAction={(item) => this.onPharmacySelected(item)}
                                        closable={selectedPharmacy !== null} selectedStoreNumber={sourceStoreNumber}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}